import { Link } from "react-router-dom";

const FullNews = ({ id, title, image, text, color, subtitle }) => {


  return (
    <Link to={`/noticias/${id}`}>
      <div className="news-section" style={{ backgroundColor: 'transparent' }}>
        <div className="content">
          <img src={image} alt="newspaper" className="image" />
          <h1 className="title">{title}</h1>
          <p className="subtitle">Escrito por: <span>{subtitle}</span></p>
          <div dangerouslySetInnerHTML={{ __html: text }} className="text"></div>
        </div>
      </div>
    </Link>

  );
};

export default FullNews;